export default __webpack_public_path__ + "static/media/36.70a80b43.jpg";